/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Faq_A4Inputs */

const en_viewer_faq_a4 = /** @type {(inputs: Viewer_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. If you paste invalid JSON, the editor will highlight syntax errors and the tree view will show an error message indicating the issue.`)
};

const ko_viewer_faq_a4 = /** @type {(inputs: Viewer_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네. 유효하지 않은 JSON을 붙여넣으면 에디터에서 구문 오류를 강조하고, 트리 뷰에서 문제를 나타내는 오류 메시지를 표시합니다.`)
};

const ja_viewer_faq_a4 = /** @type {(inputs: Viewer_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。無効なJSONを貼り付けると、エディターがシンタックスエラーをハイライトし、ツリービューに問題を示すエラーメッセージが表示されます。`)
};

/**
* | output |
* | --- |
* | "Yes. If you paste invalid JSON, the editor will highlight syntax errors and the tree view will show an error message indicating the issue." |
*
* @param {Viewer_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_faq_a4 = /** @type {((inputs?: Viewer_Faq_A4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Faq_A4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_faq_a4(inputs)
	if (locale === "ko") return ko_viewer_faq_a4(inputs)
	return ja_viewer_faq_a4(inputs)
});